import { Bookmark } from './site-bookmark';

export enum ArcGISItemType {
  BOOKMARK = 1,
}

interface BookmarkData {
  bookmarks: Bookmark[];
}

export interface ArcGISItem {
  id?: number;
  type: ArcGISItemType;
  data: BookmarkData | unknown;
  user_id: number;
  updated_on_utc: string;
  created_on_utc: string;
}
